import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { MaxAppWidth } from '@ally/next-layout'
import { AriaLiveProvider } from '@ally/use-aria-live'
import { SnackbarProvider } from '@ally/metronome-ui'
import { AccountDetailsLoader } from '../components/AccountDetailsLoader'
import { AccountDetailsProvider } from '../services'

import { SessionService, useSessionService } from '../debit-card'
import { SpendingBucketsRedirector } from './redirectors/SpendingBucketsRedirector'
import { STKRedirector } from './redirectors/STKRedirector'
import { CheckingRedirector } from './redirectors/CheckingRedirector'
import { DefaultRedirector } from './redirectors/DefaultRedirector'

export const Router: React.FC = () => {
  useSessionService(SessionService)

  return (
    <MaxAppWidth py="md">
      <Switch>
        <Route path="/account/:id/details">
          <AccountDetailsProvider>
            <AriaLiveProvider>
              <SnackbarProvider>
                <AccountDetailsLoader />
              </SnackbarProvider>
            </AriaLiveProvider>
          </AccountDetailsProvider>
        </Route>
        <Route
          path={[
            '/account/spending-buckets/:deeplink',
            '/account/spending-buckets',
            '/bank/accounts/spending-buckets/:deeplink',
          ]}
        >
          <SpendingBucketsRedirector />
        </Route>
        <Route
          path={[
            '/bank/accounts/stk-osa/:accountId/:deeplink',
            '/bank/accounts/stk-osa/:deeplink',
            '/bank/accounts/stk-osa',
          ]}
        >
          <STKRedirector />
        </Route>
        <Route
          path={[
            '/account/coverdraft-settings',
            '/account/checking/highest-balance/activity',
          ]}
        >
          <CheckingRedirector />
        </Route>
        <Route path="/account/:deeplink">
          <DefaultRedirector />
        </Route>
      </Switch>
    </MaxAppWidth>
  )
}

export default Router
